import { Slot } from '@radix-ui/react-slot';
import classNames from 'classnames';
import { Button } from 'rsuite';
import { ButtonProps } from 'rsuite/lib/Button';
import styles from './LinkButton.module.scss';

type LinkButtonProps = {
  children: any;
  className?: string;
  fontSize?: string;
  onClick?: () => void;
  asChild?: boolean;
} & ButtonProps;

export const LinkButton = ({ children, className, fontSize, asChild, onClick }: LinkButtonProps) => {
  const Comp = asChild ? Slot : Button;

  return (
    <Comp className={classNames(styles['btn-link'], className)} style={{ fontSize }} appearance="link" onClick={onClick}>
      {children}
    </Comp>
  );
};
